import { toast } from "react-toastify";
import { H4, H5, LI, UL } from "../../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { removeItems, updateTodo } from "../../../Redux-Toolkit/Reducers/ToDoSlice";
import { ToDoProp } from "../../../Type/ToDoType";

const TodoList = () => {
  const { todoList } = useAppSelector((state) => state.todo);
  const dispatch = useAppDispatch();

  const handleRemoveTodo = (todoId: number, todo: string) => {
    dispatch(removeItems(todoId));
    toast.success(`${todo} deleted`);
  };

  const handleMarkedTodo = (item: ToDoProp) => {
    if (item.status === "completed") {
      dispatch(updateTodo({ id: item.id, status: "pending", badgeClass: "bg-light-danger text-danger"}));
      toast.error(item.title + " as Incomplete");
    } else if (item.status === "pending") {
      dispatch(updateTodo({ id: item.id, status: "completed", badgeClass: "bg-light-success text-success" }));
      toast.success(item.title + " as Complete");
    }
  };

  return (
    <div className="todo-list-body">
      <UL className="simple-list" id="todo-list">
        {todoList.length > 0
          ? todoList?.map((todo, index) => (
              <LI className={`task ${todo.status === "completed" ? "completed" : ""}`} key={index} onClick={() => handleMarkedTodo(todo)}>
                <div className="task-container m-0">
                  <H4 className="task-label">{todo.title}</H4>
                  <div className="d-flex align-items-center gap-2">
                    <span className={`badge  ${todo.badgeClass}`}>{todo.badge}</span>
                    <H5 className="assign-name m-0">{todo.timeLimit}</H5>
                    <span className="action-box large delete-btn" onClick={() => handleRemoveTodo(todo.id, todo.title)}>
                      <i className="icon">
                        <i className="icon-trash"></i>
                      </i>
                    </span>
                  </div>
                </div>
              </LI>
            ))
          : ""}
      </UL>
    </div>
  );
};
export default TodoList;
